import { render } from "./EscritorioAvisosVisitas.vue?vue&type=template&id=251ca0f6"
import script from "./EscritorioAvisosVisitas.vue?vue&type=script&lang=js"
export * from "./EscritorioAvisosVisitas.vue?vue&type=script&lang=js"

import "./EscritorioAvisosVisitas.vue?vue&type=style&index=0&id=251ca0f6&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__